module.exports = __webpack_public_path__ + "static/media/drop_location_active.03dac990.svg";